import {Component} from 'react';
import {withRouter} from 'react-router';

@withRouter
export default class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({loading: false});
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const {loading} = this.state;
    if (loading) return null;
    return this.props.children;
  }
}
